const styles = {
  // Public view
  containerSx: {
    width: "100%",
    cursor: "pointer",
  },

  imageWrapperSx: {
    overflow: "hidden",
    borderRadius: "6px",
    "& img": {
      transition: "transform 0.45s ease",
    },
    "&:hover img": {
      transform: "scale(1.05)",
    },
  },

  imageSx: {
    aspectRatio: "1/1",
    width: "100%",
    objectFit: "cover",
    backgroundColor: "#1a1a1a",
    display: "block",
  },

  infoSx: {
    mt: 1,
    px: 0.5,
    color: "white",
  },

  dateSx: {
    fontSize: { xs: "0.72rem", md: "0.78rem" },
    color: "rgba(255,255,255,0.45)",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    mb: 0.5,
  },

  titleSx: {
    fontSize: { xs: "1rem", md: "1.1rem" },
    fontWeight: 300,
    lineHeight: 1.35,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  // Admin view
  adminContainerSx: {
    display: "flex",
    alignItems: "center",
    gap: { xs: 2, md: 2.5 },
    p: { xs: 1.5, md: 2 },
    borderRadius: "8px",
    backgroundColor: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.06)",
    cursor: "pointer",
    width: "100%",
    transition: "background-color 0.15s, border-color 0.15s",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.07)",
      borderColor: "rgba(255,255,255,0.12)",
    },
  },

  adminImageSx: {
    width: { xs: 90, sm: 90, md: 100 },
    height: { xs: 90, sm: 90, md: 100 },
    objectFit: "cover",
    borderRadius: "6px",
    flexShrink: 0,
    backgroundColor: "#1a1a1a",
  },

  adminInfoBoxSx: { flex: 1, minWidth: 0 },

  adminTitleSx: {
    color: "rgba(255,255,255,0.88)",
    fontWeight: 500,
    fontSize: { xs: "0.85rem", sm: "0.92rem", md: "0.95rem" },
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  adminMetaRowSx: { display: "flex", gap: 1.5, mt: 0.4, flexWrap: "wrap" },

  adminDateSx: { color: "rgba(255,255,255,0.38)", fontSize: { xs: "0.72rem", md: "0.76rem" } },

  adminLocationSx: { color: "rgba(255,255,255,0.28)", fontSize: { xs: "0.72rem", md: "0.76rem" } },

  adminEditArrowSx: {
    color: "rgba(255,255,255,0.18)",
    fontSize: "0.68rem",
    flexShrink: 0,
    display: { xs: "none", sm: "block" },
  },
};

export default styles;
